// Compact welcome banner using the approved TIET campus photograph.
// No network calls besides the single image; the date uses the browser clock.
import React, { useMemo, useState } from "react";

export const CAMPUS_BANNER_URL =
  "https://ik.imagekit.io/7khjnlfow/email-assets/03_dsyrsv.png?updatedAt=1774118995455";

export const greetingForHour = (hour) => (hour < 12 ? "Good Morning" : hour < 17 ? "Good Afternoon" : "Good Evening");

const formatIndiaDate = (date) => {
  try {
    return new Intl.DateTimeFormat("en-IN", {
      timeZone: "Asia/Kolkata",
      weekday: "long",
      day: "numeric",
      month: "short",
      year: "numeric",
    }).format(date);
  } catch {
    return "";
  }
};

const WelcomeBanner = ({ name }) => {
  const [imageFailed, setImageFailed] = useState(false);
  const { greeting, dateText } = useMemo(() => {
    const now = new Date();
    return { greeting: greetingForHour(now.getHours()), dateText: formatIndiaDate(now) };
  }, []);

  return (
    <section className="cc-banner" aria-label="Welcome">
      {!imageFailed && (
        <img
          className="cc-banner__img"
          src={CAMPUS_BANNER_URL}
          alt=""
          decoding="async"
          onError={() => setImageFailed(true)}
        />
      )}
      <div className="cc-banner__shade" aria-hidden="true" />
      <div>
        <h1 className="cc-banner__title">
          <span className="cc-banner__greeting">{greeting},</span>
          <span className="cc-banner__name">{name}</span>
        </h1>
        <p className="cc-banner__sub">Your campus operations workspace</p>
      </div>
      {dateText ? <div className="cc-banner__date">{dateText}</div> : null}
    </section>
  );
};

export default WelcomeBanner;
